import { useMarkAsChecked } from "@/api/console/pending-assessments/useMarkAsChecked";
import { useSaveChanges } from "@/api/console/pending-assessments/useSaveChanges";
import { Button } from "@/components/ui/button";
import toast from "@/lib/toast";
import { AnswerSubCategoryDetail } from "@/schema/console/checking-assessments/AnswerSubCategoryDetail";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { mutate } from "swr";

interface ButtonGroupProps {
  id: string;
}

function ButtonGroup({ id }: ButtonGroupProps) {
  const { t } = useTranslation();
  const methods = useFormContext<AnswerSubCategoryDetail>();

  const { trigger: saveChanges, isMutating: isSaveChanging } = useSaveChanges(
    id,
    {
      onSuccess: () => {},
    },
  );

  const { trigger: markAsChecked, isMutating: isMarkAsChecking } =
    useMarkAsChecked(id, {
      onSuccess: (data) => {
        mutate(`/console/pending_assessments/answer_sub_categories/${id}`);
        toast.success(data.message);
      },
    });

  const handleSave = async (cb: (message: string) => void) => {
    toast.loading(t("save-changes-loading"));
    methods.handleSubmit((data) => {
      const answer_contents = data.answer_contents.map(
        ({ id, answer_evaluations }) => ({
          id,
          answer_evaluations: answer_evaluations.map(
            ({ content, ...rest }) => rest,
          ),
        }),
      );
      saveChanges({ answer_contents }).then((data) => {
        cb(data.message);
      });
    })();
  };

  return (
    <div className="flex gap-4">
      <Button
        isLoading={isSaveChanging || isMarkAsChecking}
        variant="outline"
        onClick={() => {
          handleSave(() => {
            toast.loading(t("mark-as-checked-loading"));
            markAsChecked();
          });
        }}
      >
        {t("mark-as-checked")}
      </Button>
      <Button
        onClick={() => {
          handleSave((message) => {
            toast.success(message);
          });
        }}
        isLoading={isSaveChanging}
      >
        {t("save-changes")}
      </Button>
    </div>
  );
}

export default ButtonGroup;
